import m from "./index274.js";
import { resolveComponent as s, createElementBlock as r, openBlock as e, normalizeClass as d, createElementVNode as i, renderSlot as n, createBlock as l, createCommentVNode as t } from "vue";
import f from "./index231.js";
const p = ["data-component"], u = { class: "flex gap-16 screen-m:gap-24" }, _ = { class: "flex flex-col" }, h = {
  key: 0,
  class: "mb-4 font-bold-headline"
}, g = { key: 1 };
function $(o, b, k, w, N, v) {
  const a = s("ms-error"), c = s("ms-information-circle");
  return e(), r("div", {
    "data-component": o.$options.name,
    class: d(["flex flex-row items-center gap-16 p-16 screen-m:gap-24 rounded-10", {
      "bg-color-alert-information-25": o.isInfoNotification,
      "bg-color-alert-negative-25": o.isErrorNotification
    }])
  }, [
    i("div", u, [
      o.isErrorNotification ? (e(), l(a, {
        key: 0,
        class: "w-40 h-40 p-8 rounded-full min-w-40 bg-color-alert-negative-100 text-color-greyscale-white"
      })) : t("", !0),
      o.isInfoNotification ? (e(), l(c, {
        key: 1,
        class: "w-40 h-40 p-8 rounded-full min-w-40 bg-color-alert-information-100 text-color-greyscale-white"
      })) : t("", !0),
      i("div", _, [
        o.$slots.headline ? (e(), r("p", h, [
          n(o.$slots, "headline")
        ])) : t("", !0),
        o.$slots.default ? (e(), r("p", g, [
          n(o.$slots, "default")
        ])) : t("", !0)
      ])
    ]),
    n(o.$slots, "button")
  ], 10, p);
}
const B = /* @__PURE__ */ f(m, [["render", $]]);
export {
  B as default
};
